export default class GrepKobling {
    KMID: number;
    LPID: number;
    GrepTekst: string;
    "grep-type": string;
    kode: string;
    status: string;
    tittel: string;
    uri: string;
    "url-data": any;
    gyldighet: string;

    constructor(grepDataLareplan: any) {
        this.KMID = grepDataLareplan.KMID;
        this.LPID = grepDataLareplan.LPID;
        this.GrepTekst = grepDataLareplan.GrepTekst;
        this["grep-type"] = grepDataLareplan["grep-type"];
        this.kode = grepDataLareplan.kode;
        this.status = grepDataLareplan.status;
        this.tittel = grepDataLareplan.tittel;
        this.uri = grepDataLareplan.uri;
        this["url-data"] = grepDataLareplan["url-data"];
        this.gyldighet = grepDataLareplan.gyldighet;
    }
}